/**
 * @fileoverview gRPC-Web generated client stub for registry
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: register.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.registry = require('./register_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.registry.RegROServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.registry.RegROServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.BeginAuthRequest,
 *   !proto.registry.BeginAuthResponse>}
 */
const methodDescriptor_RegROService_StartAuthn = new grpc.web.MethodDescriptor(
  '/registry.RegROService/StartAuthn',
  grpc.web.MethodType.UNARY,
  proto.registry.BeginAuthRequest,
  proto.registry.BeginAuthResponse,
  /**
   * @param {!proto.registry.BeginAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.BeginAuthResponse.deserializeBinary
);


/**
 * @param {!proto.registry.BeginAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.BeginAuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.BeginAuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegROServiceClient.prototype.startAuthn =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegROService/StartAuthn',
      request,
      metadata || {},
      methodDescriptor_RegROService_StartAuthn,
      callback);
};


/**
 * @param {!proto.registry.BeginAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.BeginAuthResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegROServicePromiseClient.prototype.startAuthn =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegROService/StartAuthn',
      request,
      metadata || {},
      methodDescriptor_RegROService_StartAuthn);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.FinaliseAuthRequest,
 *   !proto.registry.FinaliseAuthResponse>}
 */
const methodDescriptor_RegROService_EndAuthn = new grpc.web.MethodDescriptor(
  '/registry.RegROService/EndAuthn',
  grpc.web.MethodType.UNARY,
  proto.registry.FinaliseAuthRequest,
  proto.registry.FinaliseAuthResponse,
  /**
   * @param {!proto.registry.FinaliseAuthRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.FinaliseAuthResponse.deserializeBinary
);


/**
 * @param {!proto.registry.FinaliseAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.FinaliseAuthResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.FinaliseAuthResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegROServiceClient.prototype.endAuthn =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegROService/EndAuthn',
      request,
      metadata || {},
      methodDescriptor_RegROService_EndAuthn,
      callback);
};


/**
 * @param {!proto.registry.FinaliseAuthRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.FinaliseAuthResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegROServicePromiseClient.prototype.endAuthn =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegROService/EndAuthn',
      request,
      metadata || {},
      methodDescriptor_RegROService_EndAuthn);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.registry.RegRWServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.registry.RegRWServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.SignupRequest,
 *   !proto.registry.SignupResponse>}
 */
const methodDescriptor_RegRWService_RequestEntry = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/RequestEntry',
  grpc.web.MethodType.UNARY,
  proto.registry.SignupRequest,
  proto.registry.SignupResponse,
  /**
   * @param {!proto.registry.SignupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.SignupResponse.deserializeBinary
);


/**
 * @param {!proto.registry.SignupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.SignupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.SignupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.requestEntry =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/RequestEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RequestEntry,
      callback);
};


/**
 * @param {!proto.registry.SignupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.SignupResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.requestEntry =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/RequestEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RequestEntry);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.SignupRequest,
 *   !proto.registry.SignupResponse>}
 */
const methodDescriptor_RegRWService_RequestRecovery = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/RequestRecovery',
  grpc.web.MethodType.UNARY,
  proto.registry.SignupRequest,
  proto.registry.SignupResponse,
  /**
   * @param {!proto.registry.SignupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.SignupResponse.deserializeBinary
);


/**
 * @param {!proto.registry.SignupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.SignupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.SignupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.requestRecovery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/RequestRecovery',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RequestRecovery,
      callback);
};


/**
 * @param {!proto.registry.SignupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.SignupResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.requestRecovery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/RequestRecovery',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RequestRecovery);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.RequestRemovalRequest,
 *   !proto.registry.RequestRemovalResponse>}
 */
const methodDescriptor_RegRWService_RequestRemoval = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/RequestRemoval',
  grpc.web.MethodType.UNARY,
  proto.registry.RequestRemovalRequest,
  proto.registry.RequestRemovalResponse,
  /**
   * @param {!proto.registry.RequestRemovalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.RequestRemovalResponse.deserializeBinary
);


/**
 * @param {!proto.registry.RequestRemovalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.RequestRemovalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.RequestRemovalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.requestRemoval =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/RequestRemoval',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RequestRemoval,
      callback);
};


/**
 * @param {!proto.registry.RequestRemovalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.RequestRemovalResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.requestRemoval =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/RequestRemoval',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RequestRemoval);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.ValidateSignupRequest,
 *   !proto.registry.ValidateSignupResponse>}
 */
const methodDescriptor_RegRWService_ConsiderEntry = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/ConsiderEntry',
  grpc.web.MethodType.UNARY,
  proto.registry.ValidateSignupRequest,
  proto.registry.ValidateSignupResponse,
  /**
   * @param {!proto.registry.ValidateSignupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.ValidateSignupResponse.deserializeBinary
);


/**
 * @param {!proto.registry.ValidateSignupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.ValidateSignupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.ValidateSignupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.considerEntry =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/ConsiderEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_ConsiderEntry,
      callback);
};


/**
 * @param {!proto.registry.ValidateSignupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.ValidateSignupResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.considerEntry =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/ConsiderEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_ConsiderEntry);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.FinaliseSignupRequest,
 *   !proto.registry.FinaliseSignupResponse>}
 */
const methodDescriptor_RegRWService_AddEntry = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/AddEntry',
  grpc.web.MethodType.UNARY,
  proto.registry.FinaliseSignupRequest,
  proto.registry.FinaliseSignupResponse,
  /**
   * @param {!proto.registry.FinaliseSignupRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.FinaliseSignupResponse.deserializeBinary
);


/**
 * @param {!proto.registry.FinaliseSignupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.FinaliseSignupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.FinaliseSignupResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.addEntry =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/AddEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_AddEntry,
      callback);
};


/**
 * @param {!proto.registry.FinaliseSignupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.FinaliseSignupResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.addEntry =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/AddEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_AddEntry);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.RemoveUserRequest,
 *   !proto.registry.RemoveUserResponse>}
 */
const methodDescriptor_RegRWService_RemoveEntry = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/RemoveEntry',
  grpc.web.MethodType.UNARY,
  proto.registry.RemoveUserRequest,
  proto.registry.RemoveUserResponse,
  /**
   * @param {!proto.registry.RemoveUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.RemoveUserResponse.deserializeBinary
);


/**
 * @param {!proto.registry.RemoveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.RemoveUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.RemoveUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.removeEntry =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/RemoveEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RemoveEntry,
      callback);
};


/**
 * @param {!proto.registry.RemoveUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.RemoveUserResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.removeEntry =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/RemoveEntry',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RemoveEntry);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.ChangeBackgroundRequest,
 *   !proto.registry.ChangeBackgroundResponse>}
 */
const methodDescriptor_RegRWService_ChangeBackground = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/ChangeBackground',
  grpc.web.MethodType.UNARY,
  proto.registry.ChangeBackgroundRequest,
  proto.registry.ChangeBackgroundResponse,
  /**
   * @param {!proto.registry.ChangeBackgroundRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.ChangeBackgroundResponse.deserializeBinary
);


/**
 * @param {!proto.registry.ChangeBackgroundRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.ChangeBackgroundResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.ChangeBackgroundResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.changeBackground =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/ChangeBackground',
      request,
      metadata || {},
      methodDescriptor_RegRWService_ChangeBackground,
      callback);
};


/**
 * @param {!proto.registry.ChangeBackgroundRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.ChangeBackgroundResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.changeBackground =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/ChangeBackground',
      request,
      metadata || {},
      methodDescriptor_RegRWService_ChangeBackground);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.LogoutRequest,
 *   !proto.registry.LogoutResponse>}
 */
const methodDescriptor_RegRWService_LogoutSession = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/LogoutSession',
  grpc.web.MethodType.UNARY,
  proto.registry.LogoutRequest,
  proto.registry.LogoutResponse,
  /**
   * @param {!proto.registry.LogoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.LogoutResponse.deserializeBinary
);


/**
 * @param {!proto.registry.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.LogoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.LogoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.logoutSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/LogoutSession',
      request,
      metadata || {},
      methodDescriptor_RegRWService_LogoutSession,
      callback);
};


/**
 * @param {!proto.registry.LogoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.LogoutResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.logoutSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/LogoutSession',
      request,
      metadata || {},
      methodDescriptor_RegRWService_LogoutSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.GenerateAgentTokenRequest,
 *   !proto.registry.GenerateAgentTokenResponse>}
 */
const methodDescriptor_RegRWService_GenerateAgentToken = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/GenerateAgentToken',
  grpc.web.MethodType.UNARY,
  proto.registry.GenerateAgentTokenRequest,
  proto.registry.GenerateAgentTokenResponse,
  /**
   * @param {!proto.registry.GenerateAgentTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.GenerateAgentTokenResponse.deserializeBinary
);


/**
 * @param {!proto.registry.GenerateAgentTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.GenerateAgentTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.GenerateAgentTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.generateAgentToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/GenerateAgentToken',
      request,
      metadata || {},
      methodDescriptor_RegRWService_GenerateAgentToken,
      callback);
};


/**
 * @param {!proto.registry.GenerateAgentTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.GenerateAgentTokenResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.generateAgentToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/GenerateAgentToken',
      request,
      metadata || {},
      methodDescriptor_RegRWService_GenerateAgentToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.ListPasskeysRequest,
 *   !proto.registry.ListPasskeysResponse>}
 */
const methodDescriptor_RegRWService_ListPasskeys = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/ListPasskeys',
  grpc.web.MethodType.UNARY,
  proto.registry.ListPasskeysRequest,
  proto.registry.ListPasskeysResponse,
  /**
   * @param {!proto.registry.ListPasskeysRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.ListPasskeysResponse.deserializeBinary
);


/**
 * @param {!proto.registry.ListPasskeysRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.ListPasskeysResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.ListPasskeysResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.listPasskeys =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/ListPasskeys',
      request,
      metadata || {},
      methodDescriptor_RegRWService_ListPasskeys,
      callback);
};


/**
 * @param {!proto.registry.ListPasskeysRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.ListPasskeysResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.listPasskeys =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/ListPasskeys',
      request,
      metadata || {},
      methodDescriptor_RegRWService_ListPasskeys);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.RemovePasskeyRequest,
 *   !proto.registry.RemovePasskeyResponse>}
 */
const methodDescriptor_RegRWService_RemovePasskey = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/RemovePasskey',
  grpc.web.MethodType.UNARY,
  proto.registry.RemovePasskeyRequest,
  proto.registry.RemovePasskeyResponse,
  /**
   * @param {!proto.registry.RemovePasskeyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.RemovePasskeyResponse.deserializeBinary
);


/**
 * @param {!proto.registry.RemovePasskeyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.RemovePasskeyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.RemovePasskeyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.removePasskey =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/RemovePasskey',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RemovePasskey,
      callback);
};


/**
 * @param {!proto.registry.RemovePasskeyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.RemovePasskeyResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.removePasskey =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/RemovePasskey',
      request,
      metadata || {},
      methodDescriptor_RegRWService_RemovePasskey);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.CancelRecoveryRequest,
 *   !proto.registry.CancelRecoveryResponse>}
 */
const methodDescriptor_RegRWService_CancelRecovery = new grpc.web.MethodDescriptor(
  '/registry.RegRWService/CancelRecovery',
  grpc.web.MethodType.UNARY,
  proto.registry.CancelRecoveryRequest,
  proto.registry.CancelRecoveryResponse,
  /**
   * @param {!proto.registry.CancelRecoveryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.CancelRecoveryResponse.deserializeBinary
);


/**
 * @param {!proto.registry.CancelRecoveryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.CancelRecoveryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.CancelRecoveryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.RegRWServiceClient.prototype.cancelRecovery =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.RegRWService/CancelRecovery',
      request,
      metadata || {},
      methodDescriptor_RegRWService_CancelRecovery,
      callback);
};


/**
 * @param {!proto.registry.CancelRecoveryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.CancelRecoveryResponse>}
 *     Promise that resolves to the response
 */
proto.registry.RegRWServicePromiseClient.prototype.cancelRecovery =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.RegRWService/CancelRecovery',
      request,
      metadata || {},
      methodDescriptor_RegRWService_CancelRecovery);
};


module.exports = proto.registry;

